<script setup>
import { storeToRefs } from 'pinia';
import { useScreensizeStore } from '@stores/useScreensizeStore';
import IconRent from '@icons/ph_rent.svg';
import { trans } from '../../../_00_elements/translation';
import InvoiceDataList from './InvoiceDataList.vue';
import InvoiceFilters from './InvoiceFilters.vue';
import InvoiceTable from './InvoiceDataTable.vue';
import { PAY_BUYER_BILLING_DOCUMENTS_ENDPOINT } from '../../../_00_elements/tools/routes/routes';
import { useDataTableStore } from '../../../_00_elements/tools/store/pinia/useDataTableStore';
import CardEmptyTable from '../general/CardEmptyTable.vue';
import Icon from '../../../_01_atoms/components/Icon.vue';
import InvoiceBuyerMenu from './menu/InvoiceBuyerMenu.vue';

const { isMobile } = storeToRefs(useScreensizeStore());

const datatableStore = useDataTableStore();
datatableStore.setEndpoint(PAY_BUYER_BILLING_DOCUMENTS_ENDPOINT);

</script>

<template>
  <div class="invoices">
    <div class="invoices__content">
      <div class="invoices__header">
        <div class="invoices__header-title">
          {{ trans('gestion.invoices.buyer.title') }}
        </div>
      </div>
      <InvoiceFilters />
      <component
        :is="isMobile ? InvoiceDataList : InvoiceTable"
        :hidden-columns="[ 'client' ]"
      >
        <template #actions="{ data }">
          <InvoiceBuyerMenu :invoice="data" />
        </template>
        <template #empty-state>
          <CardEmptyTable
            :title="trans('gestion.invoice.empty.title')"
            :subtitle="trans('gestion.invoice.buyer.empty.subtitle')"
          >
            <template #icon>
              <Icon :svg="IconRent" width="32" height="32" stroke="blue" />
            </template>
          </CardEmptyTable>
        </template>
      </component>
    </div>
  </div>
</template>
